export default {
  required: "Required.",
  email_format: "Invalid e-mail.",
  phone_format: "Invalid phone.",
  file_field: "Input type not corrected.",
  file_format: "File type not supported. Support types ({format})",
  file_size: "File size not supported. File size must be smaller then {size} MB"
};
